<div class="p-modal-payment-detail">
  <ul class="p-modal-payment-detail__note">
    <li class="p-modal-payment-detail__note-item" aria-hidden="true">
      <img
        class="p-modal-payment-detail__note-icon"
        src="assets/images/icon_changed_18.svg"
        width="18"
        height="18"
        alt=""
      />
      <span
        class="p-modal-payment-detail__note-text"
        [attr.aria-label]="'reader.diffIcon' | staticMsg"
        [innerHTML]="'label.changedItem' | staticMsg"
      ></span>
    </li>
  </ul>
  <div class="p-modal-payment-detail__detail p-modal-payment-detail__detail--2col">
    <div class="p-modal-payment-detail__detail-block">
      <div class="p-modal-payment-detail__detail-row">
        <dl class="c-float-list01">
          <!-- [1.9.4] 必要マイル -->
          <div class="c-float-list01__item" *ngIf="isRequiredMiles">
            <dt
              class="c-float-list01__title c-float-list01__title--fs16 c-float-list01__title--em c-float-list01__title--gray90"
            >
              <span class="c-float-list04__title-total" [innerHTML]="'label.requiredMileage' | staticMsg"></span>
            </dt>
            <dd class="c-float-list01__contents">
              <div class="c-float-list01__contents-item c-float-list01__contents-item--em">
                <span class="c-amount c-amount--price">
                  <span
                    class="c-amount__num c-amount__num--fs24"
                    [innerHTML]="requiredMiles | milesFormat : 'currencyUnit.MIL'"
                  ></span>
                </span>
              </div>
            </dd>
          </div>
          <!-- /[1.9.4] 必要マイル -->

          <div class="c-float-list01__item">
            <!-- [1.9.5] 支払総額ラベル -->
            <dt
              class="c-float-list01__title c-float-list01__title--fs16 c-float-list01__title--em c-float-list01__title--gray90"
            >
              <span [innerHTML]="totalPaymentLabel | staticMsg"></span>
            </dt>
            <!-- /[1.9.5] 支払総額ラベル -->
            <dd class="c-float-list01__contents">
              <!-- [1.9.6] 支払総額 -->
              <ng-container *ngFor="let price of getTotalPrices">
                <div class="c-float-list01__contents-item c-float-list01__contents-item--em">
                  <em class="c-modified-element--has-icon {{ getClassModifiedElement(isDifferentTotalPrices) }}">
                    <span class="c-modified-element__text">
                      <span
                        class="c-amount c-amount--price"
                        [ngStyle]="getStylingModifiedElementText(isDifferentTotalPrices)"
                      >
                        <span
                          class="c-amount__num c-amount__num--fs24"
                          [attr.aria-label]="'reader.changeAmount' | staticMsg"
                        >
                          {{ price?.value ?? 0 | amountFormat : undefined : price?.currencyCode }}
                        </span>
                      </span>
                      <span class="c-modified-element__icon" *ngIf="isDifferentTotalPrices">
                        <!-- TODO: hard code alt image -->
                        <img
                          class="c-modified-element__icon-img"
                          src="assets/images/icon_change_10.svg"
                          width="10"
                          height="10"
                          alt="変更箇所"
                        />
                      </span>
                    </span>
                  </em>
                </div>
              </ng-container>
              <!-- /[1.9.6] 支払総額 -->
            </dd>
          </div>

          <!-- [1.9.7] 搭乗者人数 -->
          <div class="c-float-list04__item">
            <dt class="c-float-list04__title"></dt>
            <dd class="c-float-list04__contents">
              <div class="c-float-list04__contents-item"><span class="c-amount c-amount--price"></span></div>
              <div class="c-float-list04__contents-item">{{ getPassengerTypeCounts }}</div>
            </dd>
          </div>
          <!-- /[1.9.7] 搭乗者人数 -->
        </dl>
      </div>
    </div>
    <div class="p-modal-payment-detail__detail-block">
      <!-- [1.9.11] 航空券金額情報 -->
      <div class="p-modal-payment-detail__detail-row" *ngIf="isAirCouponAmountInformation">
        <dl class="c-float-list04">
          <!-- [1.9.12] 運賃総額  -->
          <div class="c-float-list04__item" *ngIf="showFareTotalPrices">
            <dt class="c-float-list04__title" [innerHTML]="'label.fare' | staticMsg"></dt>
            <dd class="c-float-list04__contents c-float-list04__contents--em">
              <ng-container *ngFor="let farePrice of fareTotalPrices">
                <div>
                  <span class="c-amount c-amount--price">
                    <span class="c-amount__num c-amount__num--fs16">
                      {{ farePrice?.value ?? 0 | amountFormat : undefined : farePrice?.currencyCode }}
                    </span>
                  </span>
                </div>
              </ng-container>
            </dd>
          </div>
          <!-- /[1.9.12] 運賃総額  -->

          <!-- [1.9.15] 税金総額 -->
          <div class="c-float-list04__item">
            <dt class="c-float-list04__title" [innerHTML]="getLabelTaxTotalPrices | staticMsg"></dt>
            <dd class="c-float-list04__contents">
              <ng-container *ngFor="let taxTotal of taxTotalPrices">
                <div>
                  <span class="c-amount c-amount--price">
                    <span class="c-amount__num c-amount__num--fs16">
                      {{ taxTotal?.value ?? 0 | amountFormat : undefined : taxTotal?.currencyCode }}
                    </span>
                  </span>
                </div>
              </ng-container>
            </dd>
          </div>
          <!-- /[1.9.15] 税金総額 -->

          <!-- [1.9.16] 発券手数料、交換発行手数料総 (航空券金額情報) -->
          <div class="c-float-list04__item">
            <dt class="c-float-list04__title" [innerHTML]="'label.fee' | staticMsg"></dt>
            <dd class="c-float-list04__contents" *ngIf="showTicketFeeTotalPrices; else TotalFeeShowZero">
              <ng-container *ngFor="let feeTotalPrice of ticketFeeTotalPrices">
                <div>
                  <span class="c-amount c-amount--price">
                    <span class="c-amount__num c-amount__num--fs16">
                      {{ feeTotalPrice?.value ?? 0 | amountFormat : undefined : feeTotalPrice?.currencyCode }}
                    </span>
                  </span>
                </div>
              </ng-container>
            </dd>
            <!-- ※0でも表示する。 -->
            <ng-template #TotalFeeShowZero>
              <dd class="c-float-list04__contents">
                <span class="c-amount c-amount--price">
                  <span class="c-amount__num c-amount__num--fs16">
                    {{ 0 | amountFormat : undefined : currencyCodeByLang }}
                  </span>
                </span>
              </dd>
            </ng-template>
          </div>
          <!-- /[1.9.16] 発券手数料、交換発行手数料総 (航空券金額情報) -->
        </dl>
      </div>
      <!-- /[1.9.11] 航空券金額情報 -->
    </div>
  </div>
</div>

<div class="p-modal-body11">
  <!--
  /=====================================================
  アイテム横並びリストが画面幅より大きくなった場合はカルーセル機能となります。
  サンプルはカルーセル状態で設置しております。（画面内に収まる場合はl-carousel01__arrowのis-availableがない状態です）
  =====================================================/
  -->
  <div class="l-carousel01 l-carousel01--in-modal-body11" aria-label="カルーセルタイトル">
    <asw-block-slider [isButtonEnable]="true">
      <div class="p-modal-payment-detail-panel-partner-airs" #scrollPanel>
        <!-- <以下、PNR情報取得API応答.data.travelers[]の要素数繰り返し>(それぞれの要素が当該搭乗者情報) -->
        <ng-container *ngFor="let traveler of data?.travelers; index as itemNumber">
          <asw-payment-item
            [travelerInput]="traveler"
            [orderDataInputInput]="data"
            [itemNumber]="itemNumber"
            [lengthTraveler]="data.travelers?.length"
          ></asw-payment-item>
        </ng-container>
        <!-- /<以下、PNR情報取得API応答.data.travelers[]の要素数繰り返し>(それぞれの要素が当該搭乗者情報) -->
      </div>
    </asw-block-slider>
  </div>
</div>
